import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-datenschutz',
  templateUrl: './page-datenschutz.component.html',
  styleUrls: ['./page-datenschutz.component.scss']
})
export class PageDatenschutzComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
